import { get_credits, confirmPayCredit, getCustomers } from "@/api/receivable";

export const state = {
  loading: false,
  loadingConfirmPay: false,
  receivables: [],
  print_data: {},
  customers: [],
  loadingCustomers: false,
  meta: {
    current_page: 0,
    from: 0,
    last_page: 0,
    total: 0,
    to: 0,
    per_page: 0,
  },
};

export const getters = {
  loading: (state) => state.loading,
  receivables: (state) => state.receivables,
  print_data: (state) => state.print_data,
  loadingConfirmPay: (state) => state.loadingConfirmPay,
  customers: (state) => state.customers,
  loadingCustomers: (state) => state.loadingCustomers,
  meta: (state) => state.meta,
};
export const mutations = {
  setMeta(state, payload) {
    state.meta = payload;
  },
  setPrint(state, payload) {
    state.print_data = payload;
  },
  getCustomers(state) {
    state.loadingCustomers = true;
    state.customers = [];
  },
  getCustomersDone(state, payload) {
    state.loadingCustomers = false;
    state.customers = payload;
  },
  getCustomersFail(state) {
    state.loadingCustomers = false;
    state.customers = [];
  },
  getReceivables(state) {
    state.loading = true;
    state.receivables = [];
  },
  getReceivablesDone(state, payload) {
    state.loading = false;
    state.receivables = payload;
  },
  getReceivablesFail(state) {
    state.loading = false;
    state.receivables = [];
  },
  clear(state, payload) {
    state.loading = false;
    state.receivables = payload;
  },
  removeOne(state, payload) {
    state.receivables.splice(
      state.receivables.map((item) => item.id).indexOf(payload.id),
      1
    );
  },
  addOne(state, payload) {
    state.receivables.unshift(payload);
  },
  confirmPay(state) {
    state.loadingConfirmPay = true;
  },
  confirmPayDone(state, payload) {
    state.loadingConfirmPay = false;
  },
  confirmPayFail(state) {
    state.loadingConfirmPay = false;
  },
};

export const actions = {
  setPrint({ commit }, payload) {
    console.log(payload);
    commit("setPrint", payload);
  },
  async getCustomers({ commit }, payload) {
    commit("getCustomers");
    try {
      const response = await getCustomers(payload);
      commit("getCustomersDone", response.items);
    } catch (error) {
      commit("getCustomersFail");
      throw error;
    }
  },
  async getReceivables({ commit }, payload) {
    commit("getReceivables");
    try {
      const response = await get_credits(payload);
      commit("getReceivablesDone", response.items);
      commit("setMeata", response.meta);
    } catch (error) {
      commit("getReceivablesFail");
      throw error;
    }
  },

  async getAllReceivables({ commit }, payload) {
    commit("getReceivables");
    try {
      const response = await get_credits(payload);
      commit("getReceivablesDone", response.items);
      commit("setMeta", response.meta);
    } catch (error) {
      commit("getReceivablesFail");
      throw error;
    }
  },

  clear({ commit }, payload) {
    commit("clear", payload);
  },
  removeOne({ commit }, payload) {
    commit("removeOne", payload);
  },
  addOne({ commit }, payload) {
    commit("addOne", payload);
  },
  async confirmPay({ commit }, payload) {
    commit("confirmPay");
    try {
      const response = await confirmPayCredit(payload);
      commit("confirmPayDone", response.items);
    } catch (error) {
      commit("confirmPayFail");
      throw error;
    }
  },
};
